export const DELETION_GRACE_DAYS = 30;

export function getPermanentDeletionDate(scheduledAt: string | Date): Date {
  const base = scheduledAt instanceof Date ? scheduledAt : new Date(scheduledAt);
  return new Date(base.getTime() + DELETION_GRACE_DAYS * 24 * 60 * 60 * 1000);
}
